import { mapState, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    token: (state) => state.token,
    tokenParsed: (state) => state.tokenParsed,
    refreshToken: (state) => state.refreshToken,
  })
}

export const multiauthComputed = {
  ...mapState('multiauth', {
    tokens: (state) => state.tokens,
    tokensParsed: (state) => state.tokensParsed,
    refreshTokens: (state) => state.refreshTokens,
  })
}

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader,
  })
}

export const loaderComputed = {
  ...mapState('loader', {
    loading: (state) => state.loading
  })
}

export const windowComputed = {
  ...mapState('window', {
    windowWidth: (state) => state.windowWidth,
    xxl: (state) => state.xxl,
    xl: (state) => state.xl,
    lg: (state) => state.lg,
    md: (state) => state.md,
    sm: (state) => state.sm,
    xm: (state) => state.xm,
    isMobile: (state) => state.isMobile,
    isTablet: (state) => state.isTablet,
    isPhone: (state) => state.isPhone,
  })
}

export const etotemlayoutComputed = {
  ...mapState('etotemlayout', {
    loadingLayoutTotem: (state) => state.loadingLayoutTotem,
    corPadrao: (state) => state.corPadrao,
    corFonte: (state) => state.corFonte,
    logo: (state) => state.logo,
  })
}

export const sessaoComputed = {
  ...mapState('sessao', {
    idSessao: (state) => state.idSessao,
    empresa: (state) => state.empresa,
    totem: (state) => state.totem,
    templates: (state) => state.templates,
    filas: (state) => state.filas,
    senhas: (state) => state.senhas,
  })
}

export const painelcontroleComputed = {
  ...mapState('painelcontrole', {
    empresasResponse: (state) => state.empresasResponse,
    totemResponse: (state) => state.totemResponse,
    dashboard: (state) => state.dashboard,
    estatisticas: (state) => state.estatisticas,
    tat: (state) => state.tat,
    workline: (state) => state.workline,
    benchmark: (state) => state.benchmark,
    mesSelected: (state) => state.mesSelected,
  })
}

export const totemComputed = {
  ...mapState('totem', {
    filaToRemove: (state) => state.filaToRemove,
    filaToEdit: (state) => state.filaToEdit,
    updateSubFilas: (state) => state.updateSubFilas,
    filasGuiche: (state) => state.filasGuiche,
  })
}

export const atendimentoComputed = {
  ...mapState('atendimento', {
    loadingLogInOut: (state) => state.loadingLogInOut,
    finalizando: (state) => state.finalizando,
    multiAtendimentoSplash: (state) => state.multiAtendimentoSplash,
    splash: (state) => state.splash,
    guicheSelectedGlobal: (state) => state.guicheSelectedGlobal,
  })
}


export const authMethods = mapActions('auth', [
  'signIn',
  'getRefreshToken',
  'signOut',
  'updateAuthFromLocalStorage',
])

export const multiauthMethods = mapActions('multiauth', [
  'signIn',
  'getRefreshToken',
  'signOut',
  'updateAuthFromLocalStorage',
])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue', 'initFullScreen'])

export const loaderMethods = mapActions('loader', ['changeLoading'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])


export const windowMethods = mapActions('window', [
  'changeWindowWidth',
])

export const etotemlayoutMethods = mapActions('etotemlayout', [
  'changeLoadingLayoutTotem',
  'changeCorPadrao',
  'changeCorFonte',
  'changeLogo',
  'setCorPadraoFromLocalStorage',
  'setCorFonteFromLocalStorage',
  'setLogoFromLocalStorage',
  'updateEtotemLayoutFromLocalStorage',
])

export const sessaoMethods = mapActions('sessao', [
  'setEmpresaTotem',
  'getEmpresaDetails',
  'getTotemDetails',
  'changeIdSessao',
  'changeEmpresa',
  'changeTotem',
  'changeTemplates',
  'changeFilas',
  'changeSenhas',
  'setIdSessaoFromLocalStorage',
  'updateSessaoFromLocalStorage',
])

export const painelcontroleMethods = mapActions('painelcontrole', [
  'changeEmpresaResponse',
  'changeTotemResponse',
  'changeDashboard',
  'changeEstatisticas',
  'changeTat',
  'changeWorkline',
  'changeBenchmark',
  'changeMesSelected',
  'cleanPainelControleGlobal',
])

export const totemMethods = mapActions('totem', [
  'changeFilaToRemove',
  'changeFilaToEdit',
  'changeUpdateSubFilas',
  'pushFilasGuiche',
  'removeFilasGuiche',
  'cleanTotemStore',
])

export const atendimentoMethods = mapActions('atendimento', [
  'liberarGuiche',
  'changeLoadingLogInOut',
  'changeFinalizando',
  'changeMultiAtendimentoSplash',
  'changeSplash',
  'changeGuicheSelectedGlobal',
])
